import apiClient from "./apiClient";

export const fetchUserData = async () => {
  try {
    const response = await apiClient.get("/user/get-user");
    return response.data;
  } catch (error) {
    console.error("Error fetching user documents", error);
    throw error;
  }
};

export const updateUserDetails = async (name, email) => {
  try {
    const response = await apiClient.put("/user/update-profile", {
      name,
      email,
    });
    return response.data;
  } catch (error) {
    console.error("Error while updating user details", error);
    throw error;
  }
};

export const createLoanApplication = async (
  loanAmount,
  loanType,
  loanPurpose,
  customerUUID
) => {
  try {
    const response = await apiClient.post("/application/create", {
      loan_amount: loanAmount,
      loan_type: loanType,
      loan_purpose: loanPurpose,
      customer_uuid: customerUUID,
    });
    return response.data;
  } catch (error) {
    console.error("Error while creating your loan application", error);
    throw error;
  }
};

export const updateCompanyDetails = async (
  company_name,
  indentityId,
  company_website,
  state,
  bussiness_type,
  current_year_revenue,
  last_year_revenue
) => {
  try {
    const response = await apiClient.put("/company/update", {
      name: company_name,
      identity_id: indentityId,
      company_website,
      state,
      bussiness_type,
      current_year_revenue,
      last_year_revenue,
    });
    return response.data;
  } catch (error) {
    console.error("Error while updating user details", error);
    throw error;
  }
};

export const addDirector = async (
  name,
  pan_number,
  ownershipPercentage,
  email,
  phone,
  companyName,
  asOn = "",
  designation = "null"
) => {
  if (!Boolean(asOn?.length)) {
    const currentDate = new Date();
    asOn = currentDate.toISOString().split("T")[0];
  }

  try {
    const response = await apiClient.post("/director/add", {
      name,
      director_pan: pan_number,
      ownership_percentage: ownershipPercentage,
      email: email,
      phone: phone,
      company_name: companyName,
      as_on: asOn,
      designation,
    });
    return response.data;
  } catch (error) {
    console.error("Error while adding Director", error);
    throw error;
  }
};

export const getAllDirectors = async () => {
  try {
    const response = await apiClient.get("/director/");
    return response.data;
  } catch (error) {
    console.error("Error fetching all directors", error);
    throw error;
  }
};

export const getCompanyDetails = async () => {
  try {
    const response = await apiClient.get("/company/get-company");
    return response.data;
  } catch (error) {
    console.error("Error fetching user documents", error);
    throw error;
  }
};
